import React from "react";

const Loader = () => {
  return (
    <div className='loader-wrapper'>
      <div id='loader'>
        <div id='shadow'></div>
        <div id='box'></div>
      </div>
    </div>
  );
};

export default Loader;
